import { css } from 'lit';

export default css`
  .content {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .record_video {
    margin-left: -24px;
    margin-bottom: -23px;
    border-bottom-left-radius: var(--amityeko-radius-large);
    border-bottom-right-radius: var(--amityeko-radius-large);
    height: 100%;
  }

  amityeko-tg-label-one::part(base) {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translate(-50%);
    background-color: var(--amityeko-color-destructive-6);
    color: var(--amityeko-color-font-light);
    border-radius: var(--amityeko-radius-tiny);
    padding: 2px 4px;
  }

  .control {
    position: absolute;
    bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .icon__wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.07);
    cursor: pointer;
  }

  amityeko-tg-title {
    text-align: center;
  }

  amityeko-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    height: 80%;
    border-radius: 50%;
    box-shadow: 0px 0px 3px 3px rgba(0, 0, 0, 0.15);
    background: var(--amityeko-color-font-light);
  }
`;
